<mat-basic-chip-option
  [value]="_category?.id"
  [selected]="selected"
  [class.selected]="selected"
  (click)="toggle()"
>
  <div class="flex gap-2">
    <div [class.animate]="animate" class="animationHolder">
      <ng-lottie [options]="animation"></ng-lottie>
    </div>
    <div class="label">
      {{ _category?.name }}
    </div>
  </div>
</mat-basic-chip-option>
